import type { MeetingServicePriceListsItem } from "./priceListsTypes"

export const restrictToPreSelected = (
    merchants: MeetingServicePriceListsItem[],
    preSelectedMerchantIds: ReadonlyArray<number>,
): MeetingServicePriceListsItem[] => merchants.filter((merchant) => preSelectedMerchantIds.includes(merchant.id))

export const sortPreSelectedFirst = (
    merchants: MeetingServicePriceListsItem[],
    preSelectedMerchantIds: ReadonlyArray<number>,
): MeetingServicePriceListsItem[] => [
    ...restrictToPreSelected(merchants, preSelectedMerchantIds),
    ...merchants.filter((merchant) => !preSelectedMerchantIds.includes(merchant.id)),
]

export const filterPriceList = (
    isFavorite: boolean,
    searchRegex: RegExp | undefined,
    merchants: MeetingServicePriceListsItem[],
): MeetingServicePriceListsItem[] => {
    if (!isFavorite && !searchRegex) return merchants

    return merchants
        .map((merchant) => {
            // searchRegex has no "g" flag, so test() is stateless and safe to call repeatedly
            const matchesMerchant = !!searchRegex && searchRegex.test(merchant.displayName)

            const filteredPriceLists = merchant.priceLists.filter((priceList) => {
                const passesSearch =
                    searchRegex && !matchesMerchant
                        ? [priceList.displayName, priceList.tag, priceList.messageToCustomers].some(
                              (text) => !!text && searchRegex.test(text),
                          )
                        : true
                const isProductFavorite = isFavorite ? !!priceList.isFavorite : true
                return passesSearch && isProductFavorite
            })

            if (filteredPriceLists.length === merchant.priceLists.length) {
                const isSame = filteredPriceLists.every((pl, idx) => pl === merchant.priceLists[idx])
                if (isSame) return merchant
            }

            return {
                ...merchant,
                priceLists: filteredPriceLists,
            }
        })
        .filter((merchant) => merchant.priceLists.length > 0)
}
